import { SidebarDropdownMenu, SidebarItem } from '@vtblife/layout-config/types';
import { matchPath, useLocation } from 'react-router-dom';

const getMatchPathProps = (item: SidebarItem) => {
    const routesArray =
        item.activeRoute !== undefined
            ? typeof item.activeRoute === 'string'
                ? [item.activeRoute]
                : item.activeRoute.slice()
            : [];

    const routesFiltered = routesArray.filter((route) => typeof route === 'string' && route !== ''); // проверка, что строка не пустая

    const routes = routesFiltered.length > 0 ? routesFiltered : [item.path || item.url || ''];

    return routes.map((route) => ({
        path: route,
        exact: item.exact,
    }));
};

const matchAny = (pathname: string, item: SidebarItem) => {
    return getMatchPathProps(item).some((props) => Boolean(matchPath(pathname, props)));
};

export const useSidebarActiveItemsProps = (item: SidebarItem) => {
    const { pathname } = useLocation();

    let dropdownMenu: SidebarDropdownMenu[] | undefined;

    if (item.dropdownMenu) {
        dropdownMenu = item.dropdownMenu.map((subItem) => ({
            ...subItem,
            active: matchAny(pathname, subItem),
        }));
    }

    const isActive = dropdownMenu ? dropdownMenu.some((item) => item.active) : matchAny(pathname, item);

    return { isActive, dropdownMenu };
};
